<template>
  <div class="mpf-u-margin-bottom-6">
    <p>
      For security reasons, your session automatically ends if you have not been active for 10
      minutes.
    </p>
    <p>If you were entering information, it has not been saved and you will need to re-enter</p>
  </div>
  <MpfButton v-if="showStartAgain" label="Start again" @click="startAgain" />
</template>

<script setup lang="ts">
  import { useTenantStore } from '@/stores/useTenantStore';
  import MpfButton from '@/lib/components/MpfButton/MpfButton.vue';
  import { router } from '@/router';
  import * as Sentry from '@sentry/vue';
  import { computed } from 'vue';
  import { storeToRefs } from 'pinia';
  import { useNhsAppStore } from '@/stores/useNhsAppStore';
  const nhsAppStore = useNhsAppStore();
  const { isNhsWebApp, isOpenInNhsApp } = storeToRefs(nhsAppStore);

  const tenantStore = useTenantStore();
  const startAgain = () => router.push(`/start`);

  // NB. none router method to show / hide the start button if isNhsWebApp
  const showStartAgain = computed(() => {
    return tenantStore?.tenant?.tenantId && !isNhsWebApp.value && !isOpenInNhsApp.value ;
  });

  Sentry.captureMessage(`Session timeout`, {
    level: 'info',
  });
</script>
